import React from "react";
import { ArrowUpRight } from "lucide-react";


export default function OurWork() {
    return (
        <section id="our-work" className="bg-charcoal text-offwhite py-14 md:py-20" data-testid="section-our-work">
            <div className="max-w-[1200px] mx-auto px-6 md:px-10">
                <p className="font-manrope font-semibold text-terracotta text-[12px] tracking-[0.22em] uppercase mb-4">Our projects</p>
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
                    <h2 className="font-manrope font-bold text-offwhite text-[30px] md:text-[40px] leading-[1.05] tracking-tight">
                        See what we've designed and built
                    </h2>
                <div className="md:text-right">
                    <a
                        href="https://studio-g4.co.uk"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 font-manrope font-bold text-[15px] px-6 py-3 rounded-md border border-terracotta text-offwhite hover:bg-terracotta transition-colors"
                        data-testid="our-work-link"
                    >
                        View our projects on Studio G4 <ArrowUpRight size={18} />
                    </a>
                    <p className="mt-3 font-inter text-offwhite/60 text-[13px]" data-testid="our-work-trading-name">
                        London Renovation Specialists is a trading name of Studio G4 Ltd.
                    </p>
                </div>
                </div>
            </div>
        </section>
    );
}
